module.exports = {
	"classes": [
		"opensource-page",
		"header-dark"
	],
	"title": "Open Source",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/opensource/metadata.json
// module id = 1135
// module chunks = 0